import { FeatureFlagKey } from "@app/core/services/feature-flag.service";
import { APP_ROUTES } from "@shared/constants/app-routes.constants";

export type EnrichmentMode = "current" | "price";

export interface EnrichmentModeSpec {
  label: string;
  root: string;
  flag: FeatureFlagKey | null;
}

export const ENRICHMENT_MODES: Readonly<
  Record<EnrichmentMode, EnrichmentModeSpec>
> = {
  current: {
    label: "Package view",
    root: APP_ROUTES.MANAGEMENT.ENRICHMENT.ROOT,
    flag: null,
  },
  price: {
    label: "Price view",
    root: APP_ROUTES.MANAGEMENT.ENRICHMENT_PRICE.ROOT,
    flag: "enableEnrichmentPriceMode",
  },
};

export const DEFAULT_ENRICHMENT_MODE: EnrichmentMode = "current";

export const ENRICHMENT_MODE_STORAGE_KEY = "enrichmentMode";

export function parseEnrichmentMode(raw: unknown): EnrichmentMode | null {
  return typeof raw === "string" && Object.hasOwn(ENRICHMENT_MODES, raw)
    ? (raw as EnrichmentMode)
    : null;
}
